import NotificationType from './notification-type'
import notificationEventBus from './notifications-event-bus'

export default function showNotification(
  content: React.ReactNode,
  type: NotificationType = 'default',
  durationMs: number = 5_000
) {
  notificationEventBus.emit('show', { type, content, durationMs, id: crypto.randomUUID() })
}

;(window as any).showNotification = showNotification
